import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import { ThemeProvider } from 'styled-components';

import Footer from '../components/footer';
import base from '../styles/base';
import theme from '../styles/theme';

// Add base styles to the page.
base();

const Layout = ({ children, data }) => (
  <ThemeProvider theme={theme}>
    <div>
      <Helmet>
        <title>{data.site.siteMetadata.title}</title>
        <meta name="description" content="SharePoint Design" />
        <meta name="keywords" content="Microsoft, SharePoint, design" />
        <meta property="og:title" content="SharePoint Design" />
        <meta
          property="og:image"
          content="https://spdesign.azurewebsites.net/images/illustration.png"
        />
        <meta
          property="og:description"
          content="Design beautiful and performant sites, pages, and web parts with SharePoint in Microsoft 365."
        />
        <meta property="og:url" content="https://spdesign.azurewebsites.net/" />
        <script src="scripts/insights.js" />
      </Helmet>
      {children()}
      <Footer />
    </div>
  </ThemeProvider>
);

Layout.propTypes = {
  children: PropTypes.func,
};

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js